import type { BrandSpecial } from '@iheartjane/data-access';
import { FLAGS } from '@iheartjane/feature-flags';
import { SpecialDetailStatus, getSpecialType } from '@iheartjane/menu';
import type { ComplianceLanguageSettings, Nullable } from '@iheartjane/types';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import type { BrandSpecialViewModel } from '@jane/bloom/viewModels/brandSpecialViewModel';

import { GoldBundleProgress } from './goldBundleProgress';

export const GoldInfoBox = ({
  brandSpecial,
  complianceLanguage,
  currentSpecial,
}: {
  brandSpecial: BrandSpecialViewModel;
  complianceLanguage?: Nullable<ComplianceLanguageSettings>;
  currentSpecial: BrandSpecial;
}) => {
  const { featureFlags } = useRootLoaderData();
  const isBundle = currentSpecial.special_type !== 'product';

  return (
    <SpecialDetailStatus>
      <SpecialDetailStatus.Header
        brandImage={currentSpecial.product_brand.logo_url ?? ''}
        brandName={currentSpecial.product_brand.name}
        headerImageSrc={currentSpecial.photo?.urls?.original ?? undefined}
        specialDescription={currentSpecial.description ?? ''}
        specialTerms={currentSpecial.terms ?? ''}
        specialTitle={currentSpecial.title}
        specialType={getSpecialType(
          isBundle ? 'bundle' : 'product',
          complianceLanguage,
          featureFlags[FLAGS.c1ExtendedDealsLabels]
        )}
      />
      {isBundle && (
        <GoldBundleProgress
          brandSpecial={brandSpecial}
          tagLabel={currentSpecial.discount_label ?? ''}
        />
      )}
    </SpecialDetailStatus>
  );
};
